import { formatRequest } from "../utils/function";
import axiosInstance from "./axiosInstance";

export function createSubscriber(data) {
  return axiosInstance.post(`subscriber`, formatRequest(data));
}

export function createContactUs(data) {
  return axiosInstance.post(`contact-us`, formatRequest(data));
}
